import { useFetcher } from '@remix-run/react'
import posthog from 'posthog-js'
import { useCallback } from 'react'
import { type CancelPlotSubscriptionActionData } from '#app/routes/resources+/plot.cancel-subscripton'

export const useCancelPlotSubscription = (
	plotId: string,
	subscriptionId?: string | null,
) => {
	const fetcher = useFetcher<CancelPlotSubscriptionActionData>()

	const cancelPlotSubscription = useCallback(async () => {
		console.log('cancelPlotSubscription', plotId, subscriptionId)

		if (!subscriptionId || !plotId) return

		const formData = new FormData()
		formData.append('plotId', JSON.stringify(plotId))
		formData.append('subscriptionId', JSON.stringify(subscriptionId))
		fetcher.submit(formData, {
			method: 'POST',
			action: '/resources/plot/cancel-subscripton',
		})

		posthog.capture('plot_cancel_sub', { plotId })
	}, [plotId, subscriptionId, fetcher])

	// TODO (low) optimistic update and error handling

	return cancelPlotSubscription
}
